import React from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import { ReactComponent as IconeMartin } from '../../../../assets/img/icone-martin.svg';
import MensagemMarkdown from '../MensagemMarkdown/MensagemMarkdown';
import ListaTelas from '../ListaTelas/ListaTelas';
import GraficoResposta from '../GraficoResposta/GraficoResposta';
import useMensagemAssistenteHook from './useMensagemAssistenteHook';
import './styles.scss';

// Constantes de modulo: um literal [] inline seria uma referencia nova a cada
// render e anularia o React.memo do ListaTelas e do GraficoResposta durante o
// streaming.
const SEM_TELAS = [];
const SEM_GRAFICOS = [];

/**
 * Uma resposta do assistente: avatar, balao com o Markdown, cartoes das telas
 * citadas e as acoes da mensagem.
 *
 * Durante o streaming este componente re-renderiza a cada delta -- por isso o
 * memo e as referencias estaveis. Os cartoes so chegam com a resposta HTTP, ao
 * final, entao nao participam desse ciclo.
 */
function MensagemAssistente({ mensagem, aoNavegar }) {
  const { copiar, copiado } = useMensagemAssistenteHook({ conteudo: mensagem.conteudo });

  const telas = mensagem.telas ?? SEM_TELAS;
  const graficos = mensagem.graficos ?? SEM_GRAFICOS;
  const podeCopiar = !mensagem.parcial && !mensagem.comErro && Boolean(mensagem.conteudo);

  return (
    <Box className="chat-ia-linha-assistente">
      <Box className="chat-ia-avatar" aria-hidden="true">
        <IconeMartin />
      </Box>

      <Box className="chat-ia-corpo-assistente">
        <Box
          className={`chat-ia-balao-assistente ${
            mensagem.comErro ? 'chat-ia-balao-assistente-erro' : ''
          }`}
        >
          {mensagem.comErro ? (
            <Typography variant="body2">{mensagem.conteudo}</Typography>
          ) : (
            <>
              <MensagemMarkdown conteudo={mensagem.conteudo} />
              {/* O grafico ilustra o que o texto acabou de dizer, entao vem
                  logo depois dele e antes dos cartoes de tela, que sao um
                  proximo passo e nao parte da resposta. */}
              <GraficoResposta graficos={graficos} />
              <ListaTelas telas={telas} textoResposta={mensagem.conteudo} aoNavegar={aoNavegar} />
            </>
          )}
        </Box>

        {podeCopiar && (
          <Box className="chat-ia-acoes-mensagem">
            <Tooltip title={copiado ? 'Copiado' : 'Copiar'}>
              <IconButton
                className={`chat-ia-acao ${copiado ? 'chat-ia-acao-ok' : ''}`}
                onClick={copiar}
                size="small"
              >
                {copiado ? <CheckIcon /> : <ContentCopyIcon />}
              </IconButton>
            </Tooltip>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default React.memo(MensagemAssistente);
